import React from 'react';
import { Container, Typography, Grid, Card, CardContent, CardMedia } from '@mui/material';
import Kime from './assets/images/creators/Kime.jpeg';
import Onix from './assets/images/creators/Onix.png';
import Zombcher from './assets/images/creators/Zombcher.jpeg';
import Rodri1560 from './assets/images/creators/Rodri.jpg';





const creators = [
{ name: 'Kime', role: 'Streamer', nationality: 'Argentina', image: Kime },
{ name: 'Onix', role: 'Creador de contenido', nationality: 'Argentina', image: Onix },
  { name: 'Zombcher', role: 'Streamer', nationality: 'Argentina', image: Zombcher },
  { name: 'Rodri1560', role: 'Creador de contenido', nationality: 'Argentina', image: Rodri1560 },
];

const ContentCreators = () => {
  return (
    <Container sx={{ textAlign: 'center', py: 5 }}>
       <Grid container spacing={3} justifyContent="center">
        {creators.map((creator, index) => (
          <Grid item key={index} xs={12} sm={6} md={3}>
            <Card sx={{ borderRadius: '20px', boxShadow: 3 }}>
              <CardMedia
                component="img"
                height="150"
                image={creator.image}
                alt={creator.name}
              />
              <CardContent>
                <Typography variant="h5" fontWeight="bold">
                  {creator.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {creator.role}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {creator.nationality}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ContentCreators;
